var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('img',{staticStyle:{"width":"70px","height":"70px","margin":"10px"},attrs:{"src":require("@/assets/images/txp/triangle.png")}}),_c('div',{staticClass:"mt-3"},[_c('h5',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.subtitle)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }